import axios from 'axios';
import { notify } from '@/utils';
import AuthUtils from '@/utils/auth';
const baseURL = import.meta.env.VITE_APP_API_URL;

const http = axios.create({
  baseURL,
  timeout: 30_000,
  // headers: {
  //   'Content-Type': 'application/json',
  //   Accept: 'application/json',
  //   'Access-Control-Allow-Origin': '*',
  // },
});

http.interceptors.request.use(
  (config) => {
    const token = AuthUtils.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      notify({
        message: error.response.data?.Message || 'Something went wrong',
        type: 'error'
      })
    } else {
      notify({
        message: 'Network Error',
        type: 'error'
      })
    }
    return Promise.reject(error);
  }
);

export default http;